import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import type { UpcomingSession } from '@/lib/api/trainer';

interface AttendancePickerDialogProps {
  sessions: UpcomingSession[];
  open: boolean;
  onClose: () => void;
  onPick: (session: UpcomingSession) => void;
}

export function AttendancePickerDialog({ sessions, open, onClose, onPick }: AttendancePickerDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader><DialogTitle>Take attendance</DialogTitle></DialogHeader>
        {sessions.length === 0 ? (
          <p className="py-6 text-center text-sm text-[#6b7280]">No sessions need attendance right now.</p>
        ) : (
          <div className="space-y-2">
            {sessions.map((s) => (
              <button
                key={s.id}
                type="button"
                onClick={() => onPick(s)}
                className="flex w-full items-center gap-3 rounded-2xl border border-[#ececec] px-4 py-3 text-left hover:bg-[#fafafa]"
              >
                <div className="min-w-0 flex-1">
                  <p className="text-sm font-medium text-[#111827]">{s.title}</p>
                  <p className="text-xs text-[#9ca3af]">
                    {new Date(s.scheduled_at).toLocaleString('en-US', { weekday: 'short', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })}
                  </p>
                </div>
                <span className="flex-shrink-0 rounded-md border border-[#ffd9c7] bg-[#fff1ec] px-2 py-0.5 text-[10px] font-medium text-[#ff5a1f]">
                  Take Attendance
                </span>
              </button>
            ))}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
